import { MEET_API_URL } from '../config';

const baseUrl = String(MEET_API_URL || '').replace(/\/+$/, '');

async function fetchMeeting(path, options = {}) {
  const response = await fetch(`${baseUrl}${path}`, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...(options.headers || {})
    }
  });

  const payload = await response.json().catch(() => ({}));
  if (!response.ok || payload.success === false) {
    const error = new Error(payload.message || `Meeting API error ${response.status}`);
    error.code = payload.code || 'MEETING_API_ERROR';
    error.status = response.status;
    throw error;
  }

  return payload.data || payload;
}

export function bootstrapMeetingRoom(roomUuid, joinToken) {
  return fetchMeeting(`/api/video/rooms/${roomUuid}/bootstrap?token=${encodeURIComponent(joinToken)}`);
}

export function fetchMeetingRoomStatus(roomUuid, joinToken) {
  return fetchMeeting(`/api/video/rooms/${roomUuid}/status?token=${encodeURIComponent(joinToken)}`);
}

export function fetchProviderJoinConfig(roomUuid, joinToken, options = {}) {
  return fetchMeeting(`/api/video/rooms/${roomUuid}/token`, {
    method: 'POST',
    body: JSON.stringify({
      token: joinToken,
      ...(options.avoidProvider ? { avoid_provider: options.avoidProvider } : {}),
      ...(options.clientPlatform ? { client_platform: options.clientPlatform } : {})
    })
  });
}

export function sendMeetingEvent(roomUuid, joinToken, eventType, payload = {}) {
  return fetchMeeting(`/api/video/rooms/${roomUuid}/events`, {
    method: 'POST',
    body: JSON.stringify({
      token: joinToken,
      event_type: eventType,
      payload
    })
  });
}

export function completeMeetingRoom(roomUuid, joinToken, payload = {}) {
  return fetchMeeting(`/api/video/rooms/${roomUuid}/complete`, {
    method: 'POST',
    body: JSON.stringify({
      token: joinToken,
      ...payload
    })
  });
}
